import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.jobType;

const getJobType = createSelector(getData, jobType => values(jobType));

export default getJobType;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getJobType.js